import Typography from "@mui/material/Typography";
import { ITabPanelProps } from "../../interfaces/ITabPanelProps";
import { Box } from "@mui/material";

function TabPanel(props: ITabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3, padding: "0px" }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  export default TabPanel;